import EcoCoin from "../contracts/EcoCoin"

export const drizzleOptions = {
    contracts: [
        EcoCoin
    ],
    polls: {
        accounts: 1500,
    }
}